module.exports = __webpack_public_path__ + "static/media/capacitorjs.d0787211.svg";